import MuiAccordion, { AccordionProps as MuiAccordionProps } from "@mui/material/Accordion";
import MuiAccordionSummary, { AccordionSummaryProps as MuiAccordionSummaryProps } from "@mui/material/AccordionSummary";
import MuiAccordionDetails, { AccordionDetailsProps as MuiAccordionDetailsProps } from "@mui/material/AccordionDetails";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

export const Accordion = ({ children, sx, ...props }: MuiAccordionProps) => (
    <MuiAccordion
        sx={{
            "&:before": { display: "none" },
            boxShadow: "none",
            border: "1px solid",
            borderColor: "divider",
            "&:not(:last-child)": { borderBottom: 0 },
            "&.Mui-expanded": { margin: 0 },
            ...sx,
        }}
        {...props}
    >
        {children}
    </MuiAccordion>
);

export const AccordionSummary = ({ children, sx, ...props }: MuiAccordionSummaryProps) => (
    <MuiAccordionSummary
        expandIcon={<ExpandMoreIcon />}
        sx={{
            minHeight: 48,
            "&.Mui-expanded": { minHeight: 48 },
            "& .MuiAccordionSummary-content": {
                margin: "12px 0",
                "&.Mui-expanded": { margin: "12px 0" },
            },
            ...sx,
        }}
        {...props}
    >
        {children}
    </MuiAccordionSummary>
);

export const AccordionDetails = MuiAccordionDetails;